import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import styled from '@emotion/styled';
import { spacing, mediaMax } from 'presentations/views/styles';
import { ReactNode } from 'react';

interface Props {
  steps: (string | ReactNode)[];
  activeStep: number;
  isHideLabel?: boolean;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

export default function Component(props: Props) {
  return (
    <StyledStepper
      className={props.className}
      alternativeLabel={props.orientation === 'horizontal'}
      activeStep={props.activeStep}
      orientation={props.orientation || 'horizontal'}
    >
      {props.steps.map((step, index) => (
        <Step key={index}>
          {props.isHideLabel ? (
            <StepLabel>{''}</StepLabel>
          ) : (
            <StepLabel>{step}</StepLabel>
          )}
        </Step>
      ))}
    </StyledStepper>
  );
}

const StyledStepper = styled(Stepper)`
  background-color: transparent;
  padding-bottom: ${spacing(48)};
  ${mediaMax.tablet} {
    padding: ${spacing(12)} 0 ${spacing(24)};
  }
`;
